interface Event {
    stopPropagation(): void;
}

/**
 * Returns a callback that stops propagation of an event
 * and, if supplied, calls given function with the event.
 */
export function withNoPropagation<T extends Event>(fn?: (e: T) => void) {
    return (event: T) => {
        event.stopPropagation();
        if (fn) {
            fn(event);
        }
    };
}

/**
 * Stops given event propagation.
 */
export const stopPropagation = withNoPropagation();
